import { useNativeBridge } from 'src/contexts/NativeBridgeContext';
import { useAppFrame } from 'src/shared/AppFrame/useAppFrame';
import { isBXMobileWebView } from 'src/utils/webview-detection';

interface UseStickyOffsetOptions {
  additionalOffset?: number;
  overwriteOffset?: number;
  overwriteDefaultHeaderHeight?: number;
}

export const useStickyOffset = ({
  overwriteOffset,
  overwriteDefaultHeaderHeight,
  additionalOffset = 0,
}: UseStickyOffsetOptions | undefined = {}) => {
  const { inset } = useNativeBridge();
  const { config: appFrameConfig } = useAppFrame();
  const defaultNavHeight = 56; //px - Mobile app header height
  const navHeight = overwriteDefaultHeaderHeight ?? defaultNavHeight;

  // BX Mobile webview doesn't have a MobileAppHeader, so we need to set the offset to 0
  const isBxMobile = isBXMobileWebView();
  const appFrameNoChrome = appFrameConfig?.noChrome ?? false;

  const hasNoTopHeader = isBxMobile || appFrameNoChrome;
  const headerHeight = hasNoTopHeader ? 0 : navHeight;

  return {
    top: overwriteOffset ?? headerHeight + additionalOffset + inset.top,
  };
};
